import { useData } from "./DataContext.js";

import Button from "react-bootstrap/Button";

export default function SimHome ()
{
    const gData = useData();
    const sim = gData.sim[gData.simID];

    const institution = gData.institution[sim.institutionID];
    const institutionTitle = institution.title;
    const institutionContent = institution.content;

    const scenario = gData.scenario[sim.scenarioID];
    const scenarioTitle = scenario.title;
    const scenarioContent = scenario.content;

    const duration = gData.duration[sim.durationID];
    const durationTitle = duration.title;
    const durationContent = duration.content;

    function handleStart ()
    {
	const adminCodes = Object
	    .entries(gData.group)
	    .filter(([id, group]) => { return group.simID === gData.simID && group.type === "admin"; })
	    .map(([id, group]) => group.code);
	const url = "#/play?code="+adminCodes[0];
	window.open(url, "_blank").focus();
    }

    return (
	<>
	    <div className="fs-3 text-uppercase text-center w-100 text-danger my-3">Page d'accueil en construction</div>
	    <p className="w-100 text-center my-3">
		<Button variant="primary" onClick={handleStart}>Accéder à la simulation</Button>
	    </p>
	    <div className="d-flex gap-4">
		<div className="w-100">
		    <div className="text-uppercase text-muted">Institution</div>
		    <div className="fs-5">{institutionTitle}</div>
		    <div className="fs-6 mt-2 border p-2 overflow-auto" style={{ height: 500 }}>{institutionContent}</div>		
		</div>
		<div className="w-100">
		    <div className="text-uppercase text-muted">Scénario</div>
		    <div className="fs-5">{scenarioTitle}</div>
		    <div className="fs-6 mt-2 border p-2 overflow-auto" style={{ height: 500 }}>{scenarioContent}</div>		
		</div>
		<div className="w-100">
		    <div className="text-uppercase text-muted">Format</div>
		    <div className="fs-5">{durationTitle}</div>
		    <div className="fs-6 mt-2 border p-2 overflow-auto" style={{ height: 500 }}>{durationContent}</div>		
		</div>
	    </div>
	</>
    );
}
